/* ABD mobile Sticky Add to Cart, synchronized with Refresh and ABD bundles. */
(() => {
  'use strict';
  function init(bar) {
    if (bar.dataset.abdReady === 'true') return;
    const main = document.querySelector('main product-info');
    const btn = main?.querySelector('product-form button[name="add"]');
    const sticky = bar.querySelector('[data-abd-sticky-button]');
    if (!main || !btn || !sticky) return;
    bar.dataset.abdReady = 'true';
    const price = bar.querySelector('[data-abd-sticky-price]');
    const compare = bar.querySelector('[data-abd-sticky-compare]');
    const query = window.matchMedia('(max-width:749px)');
    let mainVisible = false, chosen = null;
    function apply() {
      const label = btn.querySelector('span')?.textContent?.trim();
      sticky.textContent = chosen?.buttonText || label || 'Add to cart';
      sticky.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      price.textContent = chosen?.price || bar.dataset.basePrice;
      const older = chosen ? chosen.compare : bar.dataset.baseCompare;
      compare.textContent = older || '';
      compare.hidden = !older;
      const visible = query.matches && !mainVisible;
      bar.hidden = !query.matches;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      sticky.tabIndex = visible ? 0 : -1;
    }
    main.addEventListener('abd:bundle-change', event => { chosen = event.detail; apply(); });
    const selector = main.querySelector('[data-abd-bundles] .abd-bundle__radio:checked');
    if (selector) {
      chosen = {size:Number(selector.value), price:selector.dataset.price, compare:selector.dataset.compare, buttonText:Number(selector.value)>1?`Add ${selector.value} to cart`: 'Add to cart'};
    }
    sticky.addEventListener('click', () => { if (!sticky.disabled) btn.click(); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => { mainVisible = entries[0]?.isIntersecting || false; apply(); }, {rootMargin:'0px 0px -10% 0px'});
      io.observe(btn);
    } else {
      const check = () => { const r=btn.getBoundingClientRect(); mainVisible = r.top < window.innerHeight && r.bottom>0; apply(); };
      window.addEventListener('scroll', check, {passive:true}); check();
    }
    const observer = new MutationObserver(() => apply());
    observer.observe(btn, {attributes:true, attributeFilter:['disabled','aria-disabled'],childList:true,subtree:true,characterData:true});
    if (query.addEventListener) query.addEventListener('change', apply); else query.addListener(apply);
    apply();
  }
  const scan=()=>document.querySelectorAll('[data-abd-sticky-atc]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
